module.exports = __webpack_public_path__ + "static/media/sportsbet.0fc196e8.svg";